/* @flow */
/* eslint-disable no-console */

import axios, { AxiosXHRConfig } from 'axios';
import type { $AxiosXHR, $AxiosError } from 'axios';
import { Environments } from '../constants';
import * as SessionStorageService from '../services/SessionStorageService';

type $AxiosRequestResult = Promise<AxiosXHRConfig<*>> | AxiosXHRConfig<*>;

const isLoggingEnabled = process.env.NODE_ENV === 'development' || process.env.DL_DEBUG_HTTP === "true";

class AxiosConfiguration {
  static setRequestHeaders(headers: Object): void {
    for (const header in headers) {
      axios.defaults.headers.common[header] = headers[header];
    }
  }

  static setRequestAPIKey(apiKey: string): void {
    axios.defaults.headers.common['x-apikey'] = apiKey;
  }

  static getRequestMethod(reqMethod: ?string): string {
    return reqMethod ? reqMethod.toUpperCase() : '';
  }

  static getRequestInterceptorSuccessHandler(config: AxiosXHRConfig<mixed>): $AxiosRequestResult {
    const token = SessionStorageService.getToken();
    if (token && config.headers) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    if (isLoggingEnabled === true) console.log(`MB DL :: ${this.getRequestMethod(config.method)} ${config.url}`);
    return config;
  }

  static getRequestInterceptorErrorHandler(error: ?mixed): Promise<*> {
    return Promise.reject(error);
  }

  static getResponseInterceptorSuccessHandler(response: $AxiosXHR<*>): mixed {
    if (isLoggingEnabled === true)
      console.log(
        `MB DL :: ${this.getRequestMethod(response.config.method)} ${response.config.url} ` +
          `:: HTTP ${response.status} ${response.statusText ? response.statusText : ''}`
      );
    return response;
  }

  static getResponseInterceptorErrorHandler(error: $AxiosError<any>): mixed {
    const responseStatus = error.response ? error.response.status : '';
    const responseUrl = error.response && error.response.config.url ? error.response.config.url : '';

    if (error.response && error.response.config && error.response.config.method && responseUrl.length > 0) {
      if (process.env.NODE_ENV === Environments.ENV_DEV)
        console.error(
          `MB DL :: ${this.getRequestMethod(error.response.config.method)} ${responseUrl} ` +
            `:: HTTP ${responseStatus}`
        );
    }
    return Promise.reject(error);
  }
}

export default AxiosConfiguration;
